<template>
  <b-modal
      :hide-footer="false"
      :title="'Histórico de Entregas'"
      centered
      size="xl"
      id="historico-entrega-beneficio"
      :visible="false"
      :no-close-on-backdrop="true"
      @ok="salvarAlteracoes"
      @cancel="cancelarEdicao"
      ok-title="Salvar"
      cancel-title="Cancelar"
  >

    <b-tabs v-model="abaAtiva" content-class="mt-3">
      <!-- Aba de Listagem -->
      <b-tab title="Listagem" active>
        <div class="card card-body p-2 border rounded">
          <b-table 
          empty-text="Nenhum registro encontrado"
          :fields="[
              {
                key: 'nome_entregador',
                label: $t('Nome Entregador'),
              },
              {
                key: 'nome_recepetor',
                label: $t('Nome Receptor'),
              },
              {
                key: 'cpf_recepetor',
                label: $t('CPF Receptor'),
              },
              {
                key: 'local',
                label: $t('Local'),
              },
              {
                key: 'descricao',
                label: $t('Descrição'),
              },
              {
                key: 'quantidade_entrega',
                label: $t('Quantidade'),
              },
              {
                key: 'data_entrega',
                label: $t('Data'),
              },
              {
                key: 'actions',
                label: 'Ações',
                class: 'text-center no-print',
                thStyle: {
                  width: '120px',
                  minWidth: '120px',
                },
              },
            ]"
            :items="entregasEditaveis"
            striped
            hover
            show-empty
            small
            outlined
            stacked="xs"
            table-class="mb-3"
          >
            <template v-slot:cell(nome_entregador)="data">
              <span>{{ data.item.nome_entregador }}</span>
            </template>
            <template v-slot:cell(nome_recepetor)="data">
              <span>{{ data.item.nome_recepetor }}</span>
            </template>
            <template v-slot:cell(cpf_recepetor)="data">
              <span>{{ data.item.cpf_recepetor }}</span>
            </template>
            <template v-slot:cell(local)="data">
              <span>{{ data.item.local }}</span>
            </template>
            <template v-slot:cell(descricao)="data">
              <span>{{ data.item.descricao }}</span>
            </template>
            <template v-slot:cell(quantidade_entrega)="data">
              <span>{{ data.item.quantidade_entrega }}</span>
            </template>
            <template v-slot:cell(data_entrega)="data">
              <span>{{ data.item.data_entrega | formatDate }}</span>
            </template>
            <template v-slot:cell(actions)="data">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="editarItem(data.index)"
                title="Editar"
              >
                <i class="fas fa-edit"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </b-tab>

      <!-- Aba de Edição -->
      <b-tab title="Editar Item" :disabled="itemEditando === null">
        <div v-if="itemEditando !== null" class="card card-body p-3 border rounded">
          <h5 class="mb-3">Editando Entrega</h5>
          
          <b-row>
            <b-col md="6">
              <b-form-group label="Nome do Entregador:" label-for="nome_entregador">
                <b-form-input
                  id="nome_entregador"
                  v-model="itemEdicao.nome_entregador"
                  readonly
                  placeholder="Nome do entregador"
                />
              </b-form-group>
            </b-col>
            
            <b-col md="6">
              <b-form-group label="Data da Entrega:" label-for="data_entrega">
                <b-form-input
                  id="data_entrega"
                  :value="itemEdicao.data_entrega | formatDate"
                  readonly
                  placeholder="Data da entrega"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group label="Quem recebeu:*" label-for="nome_recepetor">
                <b-form-select
                  id="nome_recepetor"
                  v-model="itemEdicao.nome_recepetor"
                  :options="familiares"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled>Selecione quem recebeu</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback>
                  Nome do receptor é obrigatório
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            
            <b-col md="6">
              <b-form-group label="CPF do Receptor:" label-for="cpf_recepetor">
                <b-form-input
                  id="cpf_recepetor"
                  v-model="itemEdicao.cpf_recepetor"
                  placeholder="CPF do receptor"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="8">
              <b-form-group label="Local da Entrega:" label-for="local">
                <b-form-select
                  id="local"
                  v-model="itemEdicao.local"
                  :options="itensLocalEntrega"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled>Selecione o local da entrega</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            
            <b-col md="4">
              <b-form-group label="Quantidade entregue:*" label-for="quantidade_entrega">
                <b-form-input
                  id="quantidade_entrega"
                  v-model="itemEdicao.quantidade_entrega"
                  type="number"
                  min="1"
                  placeholder="Quantidade"
                  :max="this.maximoQuantidade"
                />
                <b-form-invalid-feedback>
                  Quantidade deve ser maior que zero
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group label="Descrição:" label-for="descricao">
                <b-form-textarea
                  id="descricao"
                  v-model="itemEdicao.descricao"
                  rows="3"
                  placeholder="Descrição da entrega"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <div class="d-flex justify-content-end mt-3">
            <b-button 
              variant="outline-secondary" 
              class="mr-2"
              @click="cancelarEdicaoItem"
            >
              <i class="fas fa-times mr-1"></i>
              Cancelar
            </b-button>
            <b-button 
              variant="primary"
              @click="salvarEdicaoItem"
            >
              <i class="fas fa-check mr-1"></i>
              Salvar Item
            </b-button>
          </div>
        </div>
      </b-tab>
    </b-tabs>

  </b-modal>
</template>
<script>
export default {
  props: ["beneficio"],
  data() {
    return {
      entregasEditaveis: [],
      entregasOriginais: [],
      alteracoesPendentes: false,
      abaAtiva: 0,
      itemEditando: null,
      itemEdicao: {},
      maximoQuantidade: 0,
      municipio: "",
      locaisEntregaPorMunicipio: {
        default: [
          { value: 'NA UNIDADE', text: 'NA UNIDADE' },
          { value: 'NA RESIDÊNCIA', text: 'NA RESIDÊNCIA' }
        ],
        caraguatatuba: [
          { value: "CIASC PONTE SECA", text: "CIASC PONTE SECA" },
          { value: "CIASC PEREQUÊ MIRIM", text: "CIASC PEREQUÊ MIRIM" },
          { value: "BANCO DE ALIMENTOS", text: "BANCO DE ALIMENTOS" },
          { value: "NÚCLEO JOÃO BOLINHA", text: "NÚCLEO JOÃO BOLINHA" },
          { value: "NÚCLEO ALTO DO JETUBA", text: "NÚCLEO ALTO DO JETUBA" },
          { value: "NÚCLEO PEDRA GRANDE", text: "NÚCLEO PEDRA GRANDE" }
        ]
      }
    };
  },
  computed: {
    familiares() {
      if (!this.beneficio || !this.beneficio.familia || !this.beneficio.familia.familiares) {
        return [];
      }
      
      return this.beneficio.familia.familiares.map(familiar => ({
        searchTerms: [familiar?.nome_completo, familiar?.nome_social],
        value: familiar.nome_completo,
        text: familiar.nome_completo
      }));
    },
    
    itensLocalEntrega() {
      const municipio = this.municipio.trim().toLowerCase();
      
      if (municipio === "caraguatatuba") {
        return this.locaisEntregaPorMunicipio[municipio];
      } else {
        return this.locaisEntregaPorMunicipio.default;
      }
    }
  },
  watch: {
    beneficio: {
      handler(newVal) {
        if (newVal && newVal.entregas) {
          this.inicializarEntregas();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    inicializarEntregas() {
      // Cria uma cópia das entregas
      this.entregasEditaveis = this.beneficio.entregas.map(entrega => ({
        ...entrega
      }));
      
      // Salva uma cópia original para cancelamento
      this.entregasOriginais = JSON.parse(JSON.stringify(this.entregasEditaveis));
      
      // Reset do estado de edição
      this.itemEditando = null;
      this.itemEdicao = {};
      this.abaAtiva = 0;
    },
    
    editarItem(index) {
      // Salva o índice do item sendo editado
      this.itemEditando = index;
      
      // Cria uma cópia do item para edição
      this.itemEdicao = JSON.parse(JSON.stringify(this.entregasEditaveis[index]));

      this.maximoQuantidade = this.beneficio.quantidade - this.beneficio.quantidade_entregue + this.itemEdicao.quantidade_entrega;
      
      // Muda para a aba de edição
      this.abaAtiva = 1;
    },
    
    salvarEdicaoItem() {
      // Atualiza o item na lista
      this.$set(this.entregasEditaveis, this.itemEditando, { ...this.itemEdicao });
      
      // Marca que há alterações pendentes
      this.alteracoesPendentes = true;
      
      let dados = {
        id: this.entregasEditaveis[this.itemEditando].id,
        nome_recepetor: this.entregasEditaveis[this.itemEditando].nome_recepetor,
        cpf_recepetor: this.entregasEditaveis[this.itemEditando].cpf_recepetor,
        local: this.entregasEditaveis[this.itemEditando].local,
        descricao: this.entregasEditaveis[this.itemEditando].descricao,
        quantidade_entrega: this.entregasEditaveis[this.itemEditando].quantidade_entrega,
        beneficio_id: this.beneficio.id,
        entregue: 1
      };

      axios
        .post('api/dashboard/beneficio/entrega/update', dados)
        .then((response) => {
            this.$snack.success({
                button: false,
                text: "Histórico salvo com sucesso.",
            });
        }).catch((error) => {
            this.$snack.error({
                button: false,
                text: "Erro ao salvar o histórico.",
            });
        }).finally(() => {
            this.load = false;
            // Volta para a aba de listagem
            this.abaAtiva = 0;
            this.itemEditando = null;
            this.itemEdicao = {};
        });
    },
    
    cancelarEdicaoItem() {
      // Volta para a aba de listagem sem salvar
      this.abaAtiva = 0;
      this.itemEditando = null;
      this.itemEdicao = {};
    },
    
    salvarAlteracoes() {
      if (!this.alteracoesPendentes) {
        this.$bvModal.hide('historico-entrega-beneficio');
        return;
      }
      
      // Emite evento com as alterações para o componente pai
      this.$emit('entregas-alteradas', this.entregasEditaveis);
      this.alteracoesPendentes = false;
      this.$bvModal.hide('historico-entrega-beneficio');
      window.location.reload();
    },
    
    cancelarEdicao() {
      if (this.alteracoesPendentes) {
        this.$bvModal.msgBoxConfirm('Existem alterações não salvas. Deseja realmente cancelar?', {
          title: 'Confirmar cancelamento',
          okVariant: 'danger',
          okTitle: 'Sim, cancelar',
          cancelTitle: 'Não'
        }).then(value => {
          if (value) {
            this.inicializarEntregas();
            this.alteracoesPendentes = false;
            this.$bvModal.hide('historico-entrega-beneficio');
          }
        });
      } else {
        this.$bvModal.hide('historico-entrega-beneficio');
      }
    },
    
    async buscarMunicipio() {
      this.municipio = this.$store.state.municipio.toLowerCase();
    }
  },
  
  mounted() {
    this.buscarMunicipio();
  }
};
</script>
